import * as React from "react"

import { ButtonsMainScreenProps } from "./buttons-main-screen.interface"
import { EmotionalIcons } from "./emotional-icons"
import layoutStates from "../../../recoil/atoms/layout"
import { useRecoilState, useRecoilValue } from "recoil"
import { watchPartyHostIdSelector } from "../../../recoil/atoms/watchPartyScreen"
import { brandingSelector } from "../../../recoil/atoms/room"

const _ButtonsMainScreen: React.FC<ButtonsMainScreenProps> = ({
  isTransparent,
  isMobile,
  isLandscape,
  localUserProperties,
  offTouch,
  isDesktop,
  changeSizeIconDependingHeightVideo
}) => {
  const [recordingView] = useRecoilState(layoutStates.recordingView)
  const watchPartyHostId = useRecoilValue(watchPartyHostIdSelector)
  const roomStyles = useRecoilValue(brandingSelector)
  const showAvatar = roomStyles.enableDigitalAvatar;

  return (
    <>
      {!showAvatar && !recordingView &&
        watchPartyHostId !== "modNotPresentImage" &&
        watchPartyHostId !== "modNotPresentVideo" &&
        watchPartyHostId !== "modNotPresentOverlay" && (
          <EmotionalIcons
            isMobile={isMobile}
            offTouch={offTouch}
            isTransparent={isTransparent}
            isLandscape={isLandscape}
            isDesktop={isDesktop}
            localUserProperties={localUserProperties}
            changeSizeIconDependingHeightVideo={
              changeSizeIconDependingHeightVideo
            }
          />
        )}
    </>
  )
}

export const ButtonsMainScreen = React.memo(_ButtonsMainScreen)
